import React from "react";
import { ArrowRight, Phone, MapPin } from "@phosphor-icons/react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_schaefer-services/artifacts/4i18oxku_IMG_0867.jpg";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative isolate overflow-hidden border-b border-[#C4C4B5]"
      style={{
        backgroundImage: `linear-gradient(rgba(17,17,16,0.72), rgba(17,17,16,0.55)), url('${HERO_IMG}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 min-h-[86vh] flex flex-col justify-center py-24">
        <div
          data-testid="hero-overline"
          className="inline-flex items-center gap-2 uppercase text-xs tracking-[0.25em] font-bold text-[#E5231A] mb-6"
        >
          <MapPin size={14} weight="fill" />
          Abilene, TX &amp; Surrounding Areas
        </div>

        <h1
          data-testid="hero-heading"
          className="font-display font-black uppercase tracking-tighter text-[#F4F4EB] text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.9] max-w-5xl"
        >
          Dirt Work{" "}
          <span className="text-[#E5231A]">Done Right</span>.
          <br />
          Built To Last.
        </h1>

        <p
          data-testid="hero-subheading"
          className="mt-8 max-w-2xl text-base md:text-lg leading-relaxed text-[#F4F4EB]/80"
        >
          From land clearing and pad building to pergolas, decks, ponds and
          private roads — Michael Schaefer and crew bring the heavy equipment,
          the experience, and the work ethic to get your project done right
          the first time.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 sm:items-center">
          <a
            href="#contact"
            data-testid="hero-cta-quote"
            className="btn-hard inline-flex items-center justify-center gap-2 bg-[#E5231A] text-[#F4F4EB] font-bold uppercase text-sm tracking-wider px-7 py-4 border border-[#F4F4EB]"
          >
            Request a Free Quote
            <ArrowRight size={18} weight="bold" />
          </a>
          <a
            href="tel:+13255133501"
            data-testid="hero-cta-call"
            className="inline-flex items-center justify-center gap-2 bg-transparent text-[#F4F4EB] font-bold uppercase text-sm tracking-wider px-7 py-4 border border-[#F4F4EB] hover:bg-[#F4F4EB] hover:text-[#111110] transition-colors"
          >
            <Phone size={18} weight="fill" />
            (325) 513-3501
          </a>
        </div>

        <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-px bg-[#F4F4EB]/20 border border-[#F4F4EB]/20 max-w-3xl">
          {[
            ["16+", "Services Offered"],
            ["100%", "Owner Operated"],
            ["Free", "On-Site Quotes"],
            ["TX", "Local & Licensed"],
          ].map(([k, v]) => (
            <div
              key={v}
              className="bg-[#111110]/70 p-4 sm:p-5"
              data-testid={`hero-stat-${v.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="font-display text-2xl sm:text-3xl font-black text-[#E5231A] leading-none">
                {k}
              </div>
              <div className="mt-2 text-xs uppercase tracking-widest text-[#F4F4EB]/70">
                {v}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
